import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    Switch,
    FormControlLabel
} from '@material-ui/core'
import { Spin, Icon } from 'antd';

class AddPlatformDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditPlatformDialog')
        }
        this.state = {
            dialogOpen: false,
            valid: false,
            loading: false,
            detail: {}
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(data) {
        this.setState({
            valid: false,
            detail: data
        })
    }

    OpenDialog(data) {
        this.reset(data)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false, valid: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    handlePfNameValid() {
        let valid = false
        valid = Boolean(this.state.detail.name.trim())
        return valid
    }

    handleSubmit() {
        this.setState({
            valid: true
        })
        const valid = []/** 平台名稱驗證  */
        valid.push(this.handlePfNameValid())
        if (valid.find(value => !value) === false) { return }
        this.setState({
            loading: true
        })
        const {is_active, name, pf_sub_pf_id, is_display, display_currency, display_rtp, display_logo} = this.state.detail
        const params = {
            is_active,
            name,
            pf_sub_pf_id,
            is_display,
            display_currency,
            display_rtp,
            display_logo
        }

        utils.apiRequest(
            'patch',
            API.PLATFORM_EDIT,
            params,
            (_data) => {
                this.confirm()
                this.setState({
                    loading: false
                })
            },
            (err) => {
               console.log(err)
               this.setState({
                    loading: false
                })
            },
            false
        )
    }
    antIcon() {
        return <Icon type="loading" style={{ fontSize: 18 }} spin />
    }

    render() {
        return (
            <Dialog maxWidth="xs" fullWidth open={this.state.dialogOpen}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} className={this.props.classes.root}>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('platform')}
                                InputLabelProps={{ shrink: true }}
                                value={this.state.detail.pf_id}
                                margin="dense"
                                disabled={true}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="PF ID"
                                InputLabelProps={{ shrink: true }}
                                value={this.state.detail.pf_sub_pf_id}
                                margin="dense"
                                disabled={true}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={utils.t('platformName', 'AddPlatformDialog')}
                                InputLabelProps={{ shrink: true }}
                                value={this.state.detail.name}
                                onChange={(event) => {
                                    const detail = {...this.state.detail}
                                    detail.name = event.target.value
                                    this.setState({ detail })
                                }}
                                margin="dense"
                                required={true}
                                fullWidth={true}
                                error={this.state.valid && !this.handlePfNameValid()}
                                helperText={this.state.valid && !this.handlePfNameValid() ? this.t('pfNameValid') : ''}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.statusLabel}
                                checked={this.state.detail.display_currency}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={(event) => {
                                            const detail = {...this.state.detail}
                                            detail.display_currency = event.target.checked
                                            this.setState({ detail: detail })
                                        }}
                                    />
                                }
                                label={utils.t('displayCurrencySymbolsInGame', 'AddPlatformDialog')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.statusLabel}
                                checked={this.state.detail.display_rtp}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={(event) => {
                                            const detail = {...this.state.detail}
                                            detail.display_rtp = event.target.checked
                                            this.setState({ detail: detail })
                                        }}
                                    />
                                }
                                label={utils.t('displayRTPDeclarationInGame', 'AddPlatformDialog')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.statusLabel}
                                checked={this.state.detail.display_logo}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={(event) => {
                                            const detail = {...this.state.detail}
                                            detail.display_logo = event.target.checked
                                            this.setState({ detail: detail })
                                        }}
                                    />
                                }
                                label={utils.t('displayBrandLogo', 'AddPlatformDialog')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.statusLabel}
                                checked={this.state.detail.is_active}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={() => {
                                            const statue = !this.state.detail.is_active
                                            const detail = {...this.state.detail}
                                            detail.is_active = statue
                                            this.setState({ detail })
                                        }}
                                    />
                                }
                                label={utils.t('apiStatus', 'PlatformPage')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.statusLabel}
                                checked={this.state.detail.is_display}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={() => {
                                            const statue = !this.state.detail.is_display
                                            const detail = {...this.state.detail}
                                            detail.is_display = statue
                                            this.setState({ detail })
                                        }}
                                    />
                                }
                                label={utils.t('cmsStatus', 'PlatformPage')}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => this.handleSubmit()}
                        color="primary"
                        disabled={this.state.loading}
                    >
                        {this.state.loading && <Spin indicator={this.antIcon()} className={this.props.classes.loadingIcon} />}
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        root: {
            alignItems: 'center',
        },
        labelReset: {
            marginBottom: 0
        },
        statusLabel: {
            marginLeft: 0,
            marginBottom: 0,
            '& .MuiSwitch-root': {
                marginLeft: 8
            }
        },
        loadingIcon: {
            marginRight: _theme.spacing(1),
            color: '#fff',
            lineHeight: 1
        },

    }
}

AddPlatformDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    dataService: PropTypes.object,
}

export default hoc(styles)(AddPlatformDialog)
